import { render, staticRenderFns } from "./category-leaflet.vue?vue&type=template&id=0f6235a6"
import script from "./category-leaflet.vue?vue&type=script&lang=js"
export * from "./category-leaflet.vue?vue&type=script&lang=js"
import style0 from "./category-leaflet.vue?vue&type=style&index=0&id=0f6235a6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports